import React from "react";

const HeroSection = () => {
  return (
    <section className="relative flex items-center justify-center min-h-[50vh] pt-20 pb-10 bg-gradient-to-br from-gray-900 via-purple-900 to-black text-white overflow-hidden">
      <div className="absolute inset-0 z-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-purple-800/20 to-transparent animate-pulse" />

      <div className="relative z-10 max-w-4xl text-center px-4">
        <h1 className="text-5xl md:text-6xl font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-fuchsia-500 animate-text-glow">
          The Future of Crypto Intelligence
        </h1>

        <p className="mt-6 text-lg md:text-xl text-gray-300">
          Discover trending tokens, smart money flows, and AI-generated signals. All in real-time.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
